import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-file-box-image',
  templateUrl: './file-box-image.component.html',
  styleUrls: ['./file-box-image.component.scss']
})
export class FileBoxImageComponent implements OnInit {

  @Input() imatge: string [];
  constructor() { }

  ngOnInit() {

    let i = 0;
    i++;
    this.imatge = this.imatge;

  }

}
